export function activateLoaderSelector({ utilReducer }) {
    if (utilReducer && utilReducer.activateLoader) return true;
    else return false;
}